var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.processErrorLog.fileName,"visible":_vm.show,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.show=$event},"close":function($event){return _vm.$emit('update:isVisible', false)}}},[_vm._v(_vm._s(_vm.processErrorLog.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }